/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RootMcpServerOption = {
  /**
   * The server's endpoint on this custom domain, when one exists
   */
  attachedEndpointId?: string | undefined;
  /**
   * The attached endpoint's slug (its /mcp/<slug> path on the domain), when one exists
   */
  attachedEndpointSlug?: string | undefined;
  /**
   * Whether this server currently serves the domain root
   */
  isDomainRoot: boolean;
  /**
   * The MCP server
   */
  mcpServerId: string;
  /**
   * The MCP server's display name, if set
   */
  name?: string | undefined;
  /**
   * The project the server belongs to
   */
  projectId: string;
  /**
   * The project's display name
   */
  projectName: string;
  /**
   * The MCP server's slug, if set
   */
  slug?: string | undefined;
};

/** @internal */
export const RootMcpServerOption$inboundSchema: z.ZodMiniType<
  RootMcpServerOption,
  unknown
> = z.pipe(
  z.object({
    attached_endpoint_id: z.optional(z.string()),
    attached_endpoint_slug: z.optional(z.string()),
    is_domain_root: z.boolean(),
    mcp_server_id: z.string(),
    name: z.optional(z.string()),
    project_id: z.string(),
    project_name: z.string(),
    slug: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "attached_endpoint_id": "attachedEndpointId",
      "attached_endpoint_slug": "attachedEndpointSlug",
      "is_domain_root": "isDomainRoot",
      "mcp_server_id": "mcpServerId",
      "project_id": "projectId",
      "project_name": "projectName",
    });
  }),
);

export function rootMcpServerOptionFromJSON(
  jsonString: string,
): SafeParseResult<RootMcpServerOption, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RootMcpServerOption$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RootMcpServerOption' from JSON`,
  );
}
